// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"So-z","imageAndVideoCount":"To-z","imageAndVideoContainer":"Uo-z","viewAllReviews":"Vo-z"};